import { updateUsername } from "actions/updateUserName";
import { useEffect } from "react";
import { useStateMachine } from "little-state-machine";
import { Auth } from "aws-amplify";

const Authenticate = () => {
  const { state } = useStateMachine();
  const { actions } = useStateMachine(
    {
      updateUsername
    }
  );

  useEffect(() => {
    if (process.env.REACT_APP_AMPLIFY_LIVE_MODE === "true") {
      Auth.currentAuthenticatedUser()
        .then(user => {
          const getUserName = () => {
            if (user.signInUserSession.idToken.payload.given_name) {
              return `${user.signInUserSession.idToken.payload.given_name} ${user.signInUserSession.idToken.payload.family_name}`.trimEnd();
            }

            if (user.signInUserSession.idToken.payload.name) {
              return user.signInUserSession.idToken.payload.name;
            }

            if (user.username) {
              return user.username;
            }

            return undefined;
          };

          // console.log(user);
          const username = getUserName();

          if (!state.username || state.username !== username) {
            actions.updateUsername(username);
          }
        });
    }
  }, [actions, state]);

  return (<></>);
};

export default Authenticate;
